// Footstep cadence from distance travelled on the ground.

/** Metres between two footsteps at run speed. */
export const STRIDE_M = 2.3;

export class StrideTracker {
  private acc = 0;

  /** Feeds travelled distance (m); true when a footstep is due. */
  feed(distance: number): boolean {
    this.acc += distance;
    if (this.acc >= STRIDE_M) {
      this.acc -= STRIDE_M;
      // A long jump in distance (teleport, hitch) must not queue a burst of steps.
      if (this.acc > STRIDE_M) this.acc = 0;
      return true;
    }
    return false;
  }

  /** Airborne / stopped: the next step comes half a stride after touching down. */
  reset(): void {
    this.acc = STRIDE_M * 0.5;
  }
}
